const DeviceCheck = new function() {
  this.isMobile;
  this.isIOS;
  this.isAndroid;
  this.versionNumber = '1.6.0';

  this.initialize = function() {
    return new Promise((resolve) => {
      this.checkIfMobile();
      this.checkIfIOS();
      this.checkIfAndroid();
      resolve();
      /*console.log(this.isMobile);
      console.log(this.isAndroid);
      console.log(this.isIOS);*/
    });
  };

  this.checkIfMobile = function() {
    //this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
    this.isMobile = (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i)) ? true : false;
  };

  this.checkIfIOS = function() {
    //MSStream exclude because IE11 useragent includes Iphone because reasons
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  };

  this.checkIfAndroid = function() {
    var userAgent = navigator.userAgent.toLowerCase();
    this.isAndroid = (userAgent.indexOf("android") > -1) ? true : false;
  };
};

export default DeviceCheck;
